import React, { useState } from "react";
import config from "../../config";
import { FundraiserParticipantShop } from "../../Interfaces/FundraiserRole";
import fetchWithAuth from "../../services/fetchWithAuth";

const BASE_API = config.API_BASE_URL;

interface FundraiserProps {
  participantName: string;
  fundraiserName: string;
  handleApply: (participant: FundraiserParticipantShop) => void;
}

const YouAreSupportingDisplay: React.FC<FundraiserProps> = ({
  participantName,
  fundraiserName,
  handleApply,
}) => {
  const [participantCode, setParticipantCode] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to start of the day for accurate comparison

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setParticipantCode(e.target.value);

    // Reset error message when input changes
    setErrorMessage(null);
  };

  const handleApplyCode = async () => {
    if (participantCode.trim() === "") {
      setErrorMessage("Please enter a participant code.");
      return;
    }

    {
      try {
        const participantID = Number(participantCode.substring(4));
        const response = await fetch(
          `${BASE_API}fundraiser-role/store-info/${participantID}/`
        );

        if (response.status === 404) {
          setErrorMessage(
            "Participant ID not found. Please check and confirm your entry."
          );
          return;
        }

        if (!response.ok) {
          throw new Error("Network error");
        }
        const data: FundraiserParticipantShop = await response.json();

        if (new Date(data.fundraiser_end_date) < today) {
          setErrorMessage(
            "The fundraiser for the participant code you entered has already ended. Please check with your participant. If this is not true, please contact our support team"
          );
        } else if (data.participant_code === participantCode) {
          handleApply(data);
          setParticipantCode("");
        } else {
          setErrorMessage(
            "Participant ID not found. Please check and confirm your entry"
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrorMessage("Error fetching data");
      }
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.supportingText}>
        Supporting: <strong>{participantName}</strong>
      </div>
      <div style={styles.fundraiserText}>
        For fundraiser: <strong>{fundraiserName}</strong>
      </div>
      <div style={styles.infoText}>
        Info incorrect? Enter correct participant code
      </div>
      <div style={styles.inputContainer}>
        <input
          type="text"
          value={participantCode}
          onChange={handleCodeChange}
          placeholder="Enter participant code"
          style={styles.input}
        />
        <button onClick={handleApplyCode} style={styles.button}>
          Apply
        </button>
      </div>

      {/* Display error message if there is any */}
      {errorMessage && <div style={styles.errorText}>{errorMessage}</div>}
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  supportingText: {
    fontSize: "18px",
    marginBottom: "10px",
  },
  fundraiserText: {
    fontSize: "16px",
    marginBottom: "20px",
  },
  infoText: {
    fontSize: "14px",
    marginBottom: "10px",
    color: "gray",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  input: {
    padding: "10px",
    marginRight: "10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "200px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  errorText: {
    color: "red",
    marginTop: "10px",
  },
};

export default YouAreSupportingDisplay;
